var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center w-screen h-screen "},[_c('img',{attrs:{"src":_vm.logo,"draggable":"false"}})])}
var staticRenderFns = []

export { render, staticRenderFns }